//
//
//
//
//

export default {
  methods: {
    click: function click() {
      this.$emit('click');
    },
    touchmove: function touchmove(event) {
      event.preventDefault();
    }
  },
  mounted: function mounted() {
    this.$emit('mounted');
  }
};